import { useEffect, useState } from "react";
import { formatNumber } from "../services";
import { Container, GalleryHeader, ImageGallery } from "../Components";

const pics = [
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
  {
    title: "robot",
  },
  {
    title: "tablet",
  },
  {
    title: "monitor",
  },
  {
    title: "camera",
  },
  {
    title: "men",
  },
  {
    title: "robot2",
  },
];

function Library() {
  /*
   *Stores Number of Image
   */
  const [length, setLength] = useState();
  /*
   *Format number of images with comma(,)
   */
  useEffect(() => {
    setLength(formatNumber(pics.length));
  }, []);
  return (
    // <div className="mt-7">
    <Container>
      <GalleryHeader title="My Library" />
      {/* <GalleryInfo  /> */}
      <ImageGallery title={"All images"} length={length} pics={pics} />
    </Container>
    // </div>
  );
}
export default Library;
